import { MICROHABIT_TYPES, MICROHABIT_TYPE_NAMES, MICROHABIT_FOOD_TYPE, MICROHABIT_SIMPLE_TYPE } from "@/constants/microhabitTypes"
import MicrohabitRepository from "@/repositories/MicrohabitsRepository"

const DEFAULT_MICROHABIT_IMAGE = '/static-appopensalud/img/icons/morillas-svg-icons/primary/habits-food.svg'

export default {
	props: {
		type: {
			type: Number,
			required: true,
			validator: value => MICROHABIT_TYPES.includes(value)
		}
	},
	data () {
		return {
			DEFAULT_MICROHABIT_IMAGE
		}
	},
	methods: {
		goToMicrohabit (categoryId, microhabitId, reminder = false) {
			this.$router.push(`/patient/${MICROHABIT_TYPE_NAMES[this.type]}/${categoryId}/${microhabitId}${reminder ? '?reminder=true' : ''}`)
		},
		microhabitI18nName ({ plural = false }) {
			const number = plural ? 2 : 1
			return this.$tc(`patient-panel.${this.microhabitTypeName}-keyword`, number)
		}
	},
	computed: {
		microhabitRepository () {
			return new MicrohabitRepository(this.type)
		},
		microhabitTypeName () {
			return MICROHABIT_TYPE_NAMES[this.type]
		},
		isFoodMicrohabitType () {
			return this.type === MICROHABIT_FOOD_TYPE
		},
		isSimpleMicrohabitType () {
			return this.type === MICROHABIT_SIMPLE_TYPE
		},
		favoritesSectionActive () {
			return this.$store.getters['session/userHasCompanies']
		}
	}
}


// WEBPACK FOOTER //
// ./src/mixins/microhabits.mixin.js